import { defineStore } from 'pinia'

export const useSidebarStore = defineStore({
  id: 'sidebar',
  state: () => ({
    open: true,
    expanded: false,
    activeEditTab: '',
  }),
  getters: {
    getSidebar: (state) => state.open,
    getExpanded: (state) => state.expanded,
    getActiveEditTab: (state) => state.activeEditTab
  },
  actions: {
    toggleSidebar() {
      this.open = !this.open
    },
    closeSidebar() {
      this.open = false
    },
    openSidebar() {
      this.open = true
    },
    toggleExpanded() {
      this.expanded = !this.expanded
    },
    closeExpanded() {
      this.expanded = false
    },
    openExpanded() {
      this.expanded = true
    },
  }
})
